import React from "react";
import ContactUs from "./ContactUs";

import "./DevOps.css";
// import syllabusPDF from "../assets/DevOpsSyllabus.pdf";

const DevOps = () => {
  return (
    <>
      {/* ✅ Main DevOps Course Section */}
      <section className="devops-section">
        <div className="devops-container">
          <h1 className="devops-title">DevOps Training Course</h1>
          <p className="devops-subtitle">CI/CD • Cloud • Automation</p>

          <div className="devops-rating">
            <span>⭐ 4.9 Reviews</span>
          </div>

          <div className="devops-duration">
            <p><strong>Duration:</strong> 3 to 4 Months</p>
            <p><strong>15+ Guaranteed Interviews</strong></p>
          </div>

          <div className="devops-description">
            <p>
              Step into the world of modern software delivery with our
              comprehensive <strong>DevOps Training Course</strong>.
              DevOps is a powerful culture and set of practices that bridges
              the gap between <strong>Development</strong> and
              <strong> Operations</strong>, enabling faster, reliable, and
              scalable application delivery.
            </p>

            {/* <button
              className="devops-btn"
              onClick={() => window.open(syllabusPDF, "_blank")}
            >
              📘 Download Syllabus
            </button> */}
          </div>

          <h2 className="devops-heading">
            Boost Your Career with DevOps Course in Indore
          </h2>
          <p className="devops-text">
            Our DevOps course takes you from fundamentals to advanced
            real-world practices. Whether you are a fresher, developer,
            system admin, or cloud enthusiast, this course is designed to
            make you industry-ready.
          </p>

          <h2 className="devops-heading">What You Will Learn?</h2>
          <p className="devops-text">
            Learn DevOps from experienced industry mentors with hands-on
            labs, live projects, and real deployment scenarios aligned with
            current industry standards.
          </p>

          <ul className="devops-list">
            <li>
              <strong>DevOps Fundamentals:</strong> Understand DevOps culture,
              SDLC, Agile methodology, and collaboration between development
              and operations teams.
            </li>
            <li>
              <strong>Linux & Shell Scripting:</strong> Learn Linux
              administration, commands, permissions, and automation using
              shell scripts.
            </li>
            <li>
              <strong>CI/CD Pipelines:</strong> Build automated pipelines
              using Jenkins, GitHub Actions, and GitLab CI for continuous
              integration and deployment.
            </li>
            <li>
              <strong>Containerization & Kubernetes:</strong> Master Docker
              for containerization and Kubernetes for container orchestration
              and scaling.
            </li>
            <li>
              <strong>Cloud & Monitoring:</strong> Deploy applications on
              AWS, manage infrastructure, and monitor systems using tools
              like Prometheus and Grafana.
            </li>
          </ul>

          <h2 className="devops-heading">
            Why choose Codex Future for DevOps Training?
          </h2>
          <p className="devops-text">
            Want to build a high-paying career in cloud and automation?
            <strong> Codex Future Indore</strong> provides industry-oriented
            DevOps training with live projects, placement assistance, and
            interview preparation.
          </p>

          <p className="devops-text">
            Our DevOps course is structured to help you crack DevOps roles in
            top IT companies with confidence.
          </p>
        </div>
      </section>

      {/* ✅ Bottom Contact Section */}
      <ContactUs />
    </>
  );
};

export default DevOps;
